import { useToast } from "@chakra-ui/react";
import { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";

function Fallback({ error, resetErrorBoundary, reset, showToast }) {
  const toast = useToast();

  useEffect(() => {
    showToast &&
      toast({
        status: "error",
        title: "Error",
        description: "An error occurred trying to perform that action",
      });
    if (reset) resetErrorBoundary();
  }, []);
  return null;
}

const ErrorWrapper = ({
  children,
  reset = false,
  onReset,
  showToast = false,
}: {
  children: any;
  reset?: boolean;
  onReset?: () => any;
  showToast?: boolean;
}) => {
  return (
    <ErrorBoundary
      FallbackComponent={(props) => (
        <Fallback {...props} reset={reset} showToast={showToast} />
      )}
      onReset={onReset}
    >
      {children}
    </ErrorBoundary>
  );
};

export default ErrorWrapper;
